import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Home, Search, Clapperboard } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/search", label: "Search", icon: Search, id: "search" },
  { to: "/watch", label: "Watch", icon: Clapperboard, id: "watch" },
];

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* Top bar */}
      <header className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-red-900/30">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo-link">
            <Logo size="text-xl sm:text-2xl" />
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.id}
                to={l.to}
                data-testid={`nav-${l.id}`}
                className={({ isActive }) =>
                  `px-5 py-2 rounded-full text-sm font-semibold tracking-wide transition-colors duration-200 ${
                    isActive ? "text-white bg-blood/20 glow-box" : "text-white/60 hover:text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <button
            onClick={() => navigate("/search")}
            data-testid="nav-search-btn"
            className="md:hidden text-white/80 p-2"
            aria-label="Search"
          >
            <Search size={22} />
          </button>
        </div>
      </header>

      {/* Bottom mobile nav */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-black/80 backdrop-blur-xl border-t border-red-900/30">
        <div className="flex items-center justify-around h-16">
          {links.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.id}
                to={l.to}
                data-testid={`mobile-nav-${l.id}`}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 text-[11px] font-semibold transition-colors ${
                    isActive ? "text-blood" : "text-white/50"
                  }`
                }
              >
                <Icon size={22} />
                {l.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </>
  );
};
